import { DefineEvents, EventEmitter } from '../event-emitter/event-emitter';
import { EventEmitterImpl } from '../event-emitter/impls/event-emitter';
import { RpcImpl } from '../rpc/impls/rpc';
import { DefineRpcMethods, Rpc } from '../rpc/rpc';
import { PatentListContext } from './context-proxy';

export const PatentListProxy = Symbol('PatentListProxy');

export enum PatentListPageType {
    SRP = 'analytics-srp',
    Workspace = 'workspace-detail',
}

export interface PatentListPageInfo {
    /** 页面类型 */
    type: PatentListPageType;

    /** 页面完整路径 */
    fullPath: string;
}

// 定义 Host 端 RPC 方法
type RpcPatentListHost = DefineRpcMethods<{
    /**
     * 获取上下文列表
     * @deprecated 后续将废弃，使用 content-proxy 代替
     */
    getPatentListContext(): Promise<PatentListContext>;

    /**
     * 获取列表页面信息
     */
    getPatentListPageInfo(): Promise<PatentListPageInfo>;

    /**
     * 恢复列表页面状态
     * 用途：从会话历史中应用 AI 过滤结果时，需要要先恢复列表页面状态，再应用 AI 过滤结果。
     * @param pageInfo 页面信息
     */
    restorePatentListPage(pageInfo: PatentListPageInfo): Promise<{
        /** 是否在当前页恢复历史记录 */
        isRestoredOnCurrentPage: boolean;
    }>;
}>;

export type PatentListEvents = DefineEvents<{
    // 'patent-list-context-change': PatentListContext;
}>;

export interface PatentListProxy {
    eventProxy: EventEmitter<PatentListEvents>;
    rpcHost: Rpc<RpcPatentListHost>;
}

export function createPatentListProxy(): PatentListProxy {
    return {
        eventProxy: new EventEmitterImpl<PatentListEvents>(),
        rpcHost: new RpcImpl<RpcPatentListHost>(),
    };
}
